module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr_durch_Wassereinbruch.9e72a253.svg";